var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18457_11986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.0515 65.5H10.6558C7.28682 65.5 4.6665 62.7868 4.6665 59.2985V21.7016C4.6665 18.2132 7.28682 15.5 10.6558 15.5H69.0515C72.4205 15.5 75.0408 18.2132 75.0408 21.7016V59.686C74.6665 62.7868 72.0462 65.5 69.0515 65.5ZM10.6558 20.1512C9.90715 20.1512 9.15848 20.9264 9.15848 21.7016V59.686C9.15848 60.4612 9.90715 61.2364 10.6558 61.2364H69.0515C69.8002 61.2364 70.5489 60.4612 70.5489 59.686V21.7016C70.5489 20.9264 69.8002 20.1512 69.0515 20.1512H10.6558Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4206 27.1279H6.9126V31.7791H72.4206V27.1279Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4206 36.0427H6.9126V40.6939H72.4206V36.0427Z",
    fill: "#C84B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.613 49.6086H14.7734V54.2598H34.613V49.6086Z",
    fill: "#C84B31"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18457_11986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    fill: "white",
    transform: "translate(4.6665 15.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.491d3f245a5dbea779dd221cd7e9dd07.svg";
export { ForwardRef as ReactComponent };